export default "__VITE_ASSET__Cz203pW$__"